import "../CategoryCourses.css";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import TableCategorie from "../../../../../Component/TableCategorie/TableCategorie";
import { collection, onSnapshot, query } from "@firebase/firestore";
import { db, nmbrStudentByDomain } from "../../../../../Firebase";
import PaginationContainer from "../../../../../Component/PaginationContainer/PaginationContainer";
import { Date } from "../../../../../Services";

export default function Programmation() {
  const [myCours, setMyCours] = useState([]);
  const reftabCours = query(collection(db, "cours"));

  const getUsers = () => {
    onSnapshot(reftabCours, (item) => {
      const currentUserId = sessionStorage.getItem("user_id");
      const data = [];
      item.forEach((i) => {
        data.push({ ...i.data(), id: i.id });
      });

      setMyCours(
        data?.filter(
          (elts) =>
            elts?.admin_id === currentUserId ||
            elts?.created_by === currentUserId
        )
      );
    });
  };

  useEffect(() => {
    getUsers();
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  const handelChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const allCourses = myCours.filter((item) => item.isArchived === false);
  const coursProgrammatiom = allCourses.filter(
    (item) => item.domaine.toLowerCase() === "programmation"
  );
  const filteredDatas = coursProgrammatiom.filter(
    (elt) =>
      elt?.titre_cours?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      elt?.description?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      elt?.infoUser?.toLowerCase().includes(searchTerm?.toLowerCase())
  );
  const myDatas = searchTerm === "" ? coursProgrammatiom : filteredDatas;

  return (
    <div>
      <div className="d-flex justify-content-end ajouRecher vw-30">
        <input
          type="text"
          onChange={handelChange}
          value={searchTerm}
          className="form-control"
          placeholder="Recherche cours"
        />
      </div>
      <Table
        striped
        hover
        responsive
        className="container-fluid "
        id="tableCategorie"
      >
        <thead>
          <tr>
            <th>COURS</th>
            <th>DATE CREATION</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody>
          <PaginationContainer data={myDatas.sort((a, b) => b.created_on.seconds - a.created_on.seconds)} ItemComponent={TableCategorie} />
        </tbody>
      </Table>
    </div>
  );
}
